module.exports = __webpack_public_path__ + "img/icon-search.2c16ff9f.svg";